import { useAppSelector } from 'shared/lib/redux';
import type { SliceStateFromReducer } from 'shared/types';

import type { preApprovalsSlice } from './preApprovals.slice';

export type TDeliveryState = SliceStateFromReducer<typeof preApprovalsSlice>;

export const retryTimerSecondsLeftSelector = (state: TDeliveryState) => state.preApprovals.retryTimerSecondsLeft;

export const retryTimerIsRunningSelector = (state: TDeliveryState) => state.preApprovals.isTimerRunning;

export const isSmsSendingSelector = (state: TDeliveryState) => state.preApprovals.isSmsSending;

export const lastConfirmationResultSelector = (state: TDeliveryState) => state.preApprovals.lastConfirmationResult;

export const getRetryTimerSecondsLeftThunk = (): ThunkResult<void> => (_, getState) => {
  return retryTimerSecondsLeftSelector(getState());
};

export const useRetryTimerSecondsLeft = () => {
  return useAppSelector(retryTimerSecondsLeftSelector);
};

export const useRetryTimerIsRunning = () => {
  return useAppSelector(retryTimerIsRunningSelector);
};

export const useIsSmsSending = () => {
  return useAppSelector(isSmsSendingSelector);
};

export const useLastConfirmationResult = () => {
  return useAppSelector(lastConfirmationResultSelector);
};
